import * as Utils from '@ext/index';
export { };

export class Tipos
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Tipos
    {

        if ( id === this.Unica.Id )
            return this.Unica;
        else if ( id === this.Multiple.Id )
            return this.Multiple;


        return new Tipos( id, id );
    }

    public static readonly Unica: Tipos = new Tipos( 'unica', 'Unica' );
    public static readonly Multiple: Tipos = new Tipos( 'multiple', 'Multiple' );

    public static Options: Array<Tipos> = [
        Tipos.Unica,
        Tipos.Multiple,

    ];

    public get esUnica(): boolean { return this.Id === Tipos.Unica.Id; }
    public get esMultiple(): boolean { return this.Id === Tipos.Multiple.Id; }

    public static get Filter(): { Nombre: string; Id: string, Valor: Tipos[]; }[]
    {
        let tt: { Nombre: string; Id: string, Valor: Tipos[]; }[] = [];
        for ( let t of Tipos.Options )
        {
            tt.push( { Nombre: t.Descripcion, Id: t.Id, Valor: [t] } );
        }
        return tt;
    }
}